import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { DashboardApi } from '../../../services'
import { WaterQualityParameter } from '../../../types/TestParameter'
import { RootState } from '../../store'
import { StorageUtils } from '../../Verification'
import { WaterTestStripState } from '../waterTestStrip.slice'

export const manualAnalyzeTestStripAsync = createAsyncThunk(
  'waterTestStrip/manualAnalyze',
  async (
    {
      waterQualityParameters,
      isManual,
      file,
    }: {
      waterQualityParameters: WaterQualityParameter[]
      isManual: boolean
      file?: File
    },
    { getState, rejectWithValue },
  ) => {
    try {
      const state = getState() as RootState
      const { verifiedEmail, isVerified } = state.verification
      const savedState = StorageUtils.getVerificationState()
      const email = verifiedEmail || savedState?.email

      if (!isVerified || !savedState?.isVerified) {
        throw new Error('Verification required')
      }
      const formData = new FormData()
      if( file ) {
        formData.append('image', file)
      }
      formData.append('email', email)
      formData.append('isManual', isManual.toString())
      formData.append('waterQualityParameters', JSON.stringify(waterQualityParameters))
      const response = await DashboardApi.manualAnalyzeWaterTestStrip(formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      return (response as AxiosResponse<any>).data
    } catch (error: any) {
      console.error(error)
      return rejectWithValue(error?.response?.data || 'Failed to manually analyze water test strip')
    }
  },
)

export const manualAnalyzeTestStripAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterTestStripState>,
) => {
  builder.addCase(manualAnalyzeTestStripAsync.pending, (state) => {
    state.loading = true
    state.status = 'uploading'
    state.success = false
    state.error = null
  })

  builder.addCase(manualAnalyzeTestStripAsync.fulfilled, (state, action) => {
    state.loading = false
    state.success = true
    state.status = 'completed'
    state.data = action.payload.result
  })

  builder.addCase(manualAnalyzeTestStripAsync.rejected, (state, action: PayloadAction<any>) => {
    state.loading = false
    state.success = false
    state.status = 'failed'
    state.error = action.payload
  })
}
